import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { get, post, patch } from 'helpers/api';

export const UPDATE_FILE = "UPDATE_FILE";
export function updateFile(file) {
  return { file, type: UPDATE_FILE };
}

export const ADD_FILE = "ADD_FILE";
export function addFile(file) {
  return { file, type: ADD_FILE };
}

export const UPDATE_IMPORT = "UPDATE_IMPORT";
export function updateImport(importObject) {
  return { importObject, type: UPDATE_IMPORT };
}

export function getFileStatus(file) {
  return (dispatch) => {
    get(`${file.filePath}/status`).then((response) => {
      const newFile = {
        ...file,
        status: response.status,
        completedRecords: response.complete,
        totalRecords: response.total
      };

      dispatch(updateFile(newFile));
    });
  };
}

export function createFile(formData) {
  return (dispatch, getState) => {
    const filePath = getState().paths.newFilePath;
    axios.post(filePath, formData).then((response) => {
      const file = camelcaseKeys(response.data.files[0]);
      dispatch(addFile(file));
    });
  };
}

export function cancelImport() {
  return (_dispatch, getState) => {
    const cancelImportPath = getState().paths.cancelImportPath;
    post(cancelImportPath).then((response) => {
      window.location = response.redirectUrl;
    });
  };
}

export function saveImport() {
  return (_dispatch, getState) => {
    const importObject = getState().importObject;
    const importPath = getState().paths.importPath;
    patch(importPath, {
      importerImport: {
        name: importObject.name,
        filesAttributes: Object.values(importObject.files),
      },
      step: "map"
    }).then((response) => {
      window.location = response.redirectUrl;
    });
  };
}

export function runImport() {
  return (_dispatch, getState) => {
    const runPath = getState().paths.runPath;
    patch(runPath, {
      importerRun: {
        status: "running"
      }
    }).then((response) => {
      window.location = response.redirectUrl;
    });
  };
}

export function revertImport() {
  return (_dispatch, getState) => {
    const runPath = getState().paths.runPath;
    patch(runPath, {
      importerRun: {
        status: "reverting"
      }
    }).then((response) => {
      window.location = response.redirectUrl;
    });
  };
}

export function revertFile() {
  return (_dispatch, getState) => {
    const runPath = getState().paths.runPath;
    const fileId = getState().ui.selectedFileId;
    patch(runPath, {
      importerRun: {
        status: "reverting"
      },
      fileId: fileId
    }).then((response) => {
      window.location = response.redirectUrl;
    });
  };
}

export function downloadImportSummary() {
  return (_dispatch, getState) => {
    const { paths } = getState();
    window.location.assign(paths.reviewImportPath);
  };
}

export function downloadSkippedRecords() {
  return (_dispatch, getState) => {
    const {
      runRecords: { selectedFileId },
      paths: { skippedRecordsPath }
    } = getState();

    window.location.assign(`${skippedRecordsPath}?file_id=${selectedFileId}`);
  };
}

export function downloadOriginalFile() {
  return (_dispatch, getState) => {
    const { importObject: { files }, runRecords: { selectedFileId } } = getState();
    const file = files[selectedFileId];

    window.location.assign(file.downloadFilePath);
  };
}
